// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import "./../../bindings/bao-tabs";
function MyAppsViewModel(tabPage) {
    var self = this;
    var initialiazed = false;
    SearchPaging.call(this, tabPage);
    self.UserId = ko.observable();
    self.Username = ko.observable();
    self.Lastname = ko.observable();
    self.Firstname = ko.observable();
    self.Email = ko.observable();
    self.TabViewModel = new TabController(false);
    var tabPageMyAppsTab = new TabPage();
    tabPageMyAppsTab.AutoSelect = true;
    tabPageMyAppsTab.Url("MyAppsTab");
    tabPageMyAppsTab.Title = Bao.Session.GetMessage("msgMyAppsTab");
    tabPageMyAppsTab.IsClosable(false);
    self.RefreshUser = function (userId) {
        Bao.post("MyApps/Get", JSON.stringify({
            userId: userId
        }), function (resultUserModel) {
            ko.map.fromJS(resultUserModel, self);
            self.TabPage.SessionTabId = self.SessionTabId();
        });
    };
    var baseLoaded = self.loaded;
    self.loaded = function () {
        if (baseLoaded != null) {
            baseLoaded.call(self);
        }
        self.TabViewModel.AddTab(tabPageMyAppsTab);
        initialiazed = true;
    };
    self.init = function () {
        self.RefreshUser();
    };
    self.PerformRefresh = function () {
        var self = this;
        self.TabPage.IsLoading(true);
        return Bao.post(self.RefreshUrl, JSON.stringify({
            id: self.OpenData()
        }), function (value) {
            self.TabPage.DirtyFlag.pause();
            ko.map.fromJS(value, self, self.TabPage.DirtyFlag);
            self.TabPage.ObjectId(self.OpenData());
            self.TabPage.DirtyFlag.reset();
            self.TabPage.IsLoading(false);
        }).then(function () {
            tabPageMyAppsTab.ViewModel().Refresh();
        });
        ;
    };
    self.Save = function () {
        return tabPageMyAppsTab.ViewModel().Commit("").then(function () {
            self.TabPage.DirtyFlag.reset();
        });
    };
}
;
Bao.inherit(MyAppsViewModel, SearchPaging);
MyAppsViewModel.prototype.PermissionRefresh = "MyAppsRefresh";
MyAppsViewModel.prototype.PermissionSave = "MyAppsSave";
export default MyAppsViewModel;